<template>
  <v-data-table
    :footer-props="footer"
    :headers="headers"
    :items.sync="items"
    :loading="loading"
    :multi-sort="false"
    :options.sync="options"
    :server-items-length="totalItems"
    class="elevation-0"
    item-key="id"
  >
    <template #item.created_at="{ item }">
      <span
        v-if="item.created_at"
        class="d-block"
      >{{
        $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
      }}</span>
    </template>
    <template #item.amount="{ item }">
      <span>{{
        Number(item.amount).toLocaleString("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        })
      }}</span>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: 'UserAffTable',
  props: {
    userId: { default: '', Type: Number },
  },
  data: () => ({
    footer: {
      itemsPerPageOptions: [10, 25, 50, 100],
    },
    loading: true,
    search: false,
    sortable: false,
    headers: [
      {
        text: 'เลขอ้างอิงโพย',
        value: 'id',
        align: 'center',
        justify: 'center',
        sortable: false,
      },
      {
        text: 'วันที่ทำรายการ',
        value: 'created_at',
        align: 'center',
        justify: 'center',
        sortable: false,
      },
      {
        text: 'ชื่อผู้เล่น',
        value: 'credit_transaction.user.name',
        align: 'center',
        justify: 'center',
        sortable: false,
      },
      {
        text: 'ค่าแนะนำ',
        value: 'amount',
        align: 'right',
        justify: 'center',
        sortable: false,
      },
      {
        text: 'หมายเหตุ',
        value: 'remark',
        align: 'center',
        cellClass: 'text-monospace',
        sortable: false,
      },
    ],
    items: [],
    options: {},
    totalItems: 0,
  }),
  computed: {},
  watch: {
    options: {
      handler() {
        this.getAffFetch();
      },
      deep: true,
    },
  },
  methods: {
    getAffFetch() {
      if (this.userId) {
        this.loading = true;
        axios
          .get(`/api/affiliate/user/getAff/${this.userId}`, {
            params: {
              page: this.options.page,
              sortBy: this.options.sortBy[0],
              sortDirection:
                this.options.sortDesc.length > 0
                  ? this.options.sortDesc[0]
                    ? 'ASC'
                    : 'DESC'
                  : null,
              pageSize: this.options.itemsPerPage,
            },
          })
          .then((response) => {
            this.items = response.data.data;
            this.totalItems = response.data.total;
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
